import { connect } from 'react-redux';
import React, {Component} from 'react';
import {Dimmer, Loader, Segment, Header, Button, Grid} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import {style} from './style.css';
import _ from 'underscore';
import {
    getMHCRewardsDetail,
    redeemMHCRewards
} from '../../actions';
import RewardHTMLTemplate from '../../template/rewardHTMLTemplate';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import moment from 'moment';
const GLOBAL_DATETIME = 'DD MMM YYYY h:mm A'



class RewardsDetailsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isloadingActive: false,
            reward: null,
        };
    }

    componentDidMount() {
        this.setState({isloadingActive: true});
        const {accessToken} = this.props.user;
        // console.log('this.props.match.params', this.props.match.params);
        const rewardID = this.props.match.params.rewardId;
        this.props.getMHCRewardsDetail(accessToken, rewardID).then(()=>{
            this.setState({
                reward : this.props.reward
            })
            this.setState({isloadingActive: false});
        })
    }

    onRedeem(redeemId) {
        this.setState({isloadingActive: true});
        const {accessToken} = this.props.user;
        // console.log('this.props.match.params', this.props.match.params);
        const rewardID = this.props.match.params.rewardId;
        this.props.redeemMHCRewards(accessToken, rewardID).then(()=>{
            // console.log('onRedeem-success', this.props.reward);
            this.setState({
                reward : this.props.reward
            })
            this.setState({isloadingActive: false});
        })
    }

    render() {
      const linkPhone = "tel:";
      const linkEmail = "mailto:";

      const className = 'Reward'
      let htmlString = ''
      var reward = this.props.reward

      if (this.state.reward) {
            var fullImageURL = ''
            var findIndex = reward.thumbnailURL.indexOf(".100x100")
            if (findIndex != -1) {
                fullImageURL = reward.thumbnailURL.substring(0, findIndex);
            }

            let contactNo = null
            if (reward.contact_details && reward.contact_details.phone) {
                var regex = /[0-9+]/g;
                var filteredPhoneNo = reward.contact_details.phone.match(regex);
                if (filteredPhoneNo)
                    contactNo = filteredPhoneNo.join('')
            }

            htmlString = RewardHTMLTemplate.replace(/\n/g, "")
                .replace(/%%Header-Image%%/g, fullImageURL)
                .replace(/%%Header-Title%%/g, reward.title ? reward.title : '-')
                .replace(/%%Header-Description%%/g, reward.excerpt ? reward.excerpt : '-')
                .replace(/%%Call-Phone%%/g, contactNo ? linkPhone + contactNo : '-')
                .replace(/%%Content-Phone%%/g, contactNo ? contactNo : '-')
                .replace(/%%Mail-To%%/g, reward.contact_details && reward.contact_details.email ? linkEmail + reward.contact_details.email : '-')
                .replace(/%%Content-Email%%/g, reward.contact_details && reward.contact_details.email ? reward.contact_details.email : '-')
                .replace(/%%Content-Website%%/g, reward.merchant && reward.merchant.website ? reward.merchant.website : '-')
                .replace(/%%Content-About%%/g, reward.merchant && reward.merchant.description ? reward.merchant.description : '-')
                .replace(/%%Content-Terms%%/g, reward.terms_and_conditions ? reward.terms_and_conditions.replace(/&nbsp;/g, " ") : '-')
                .replace(/%%Content-Valid-Date%%/g, reward.endDate ? moment(reward.endDate).format(GLOBAL_DATETIME) : '-')
                .replace("%%Content-Address%%", reward.locations && reward.locations.length > 0 && reward.locations[0] && reward.locations[0].address ? reward.locations[0].address : "N/A");

        }
        return (
            <div>
                <Dimmer active = {this.state.isloadingActive} inverted className='dimerClass' >
                    <Loader>Loading</Loader>
                </Dimmer>
                { ReactHtmlParser(htmlString) }
              <Segment className='gridStyle'>
                {this.state.reward && !this.state.reward.redeemedDetails &&
                    <Grid.Column width={16} >
                        <Button
                            className='buttonStyle'
                            onClick={this.onRedeem.bind(this, this.props.match.params.rewardId)}
                            size="big"
                            >
                                Redeem
                        </Button>
                    </Grid.Column>

                }
                {this.state.reward && this.state.reward.redeemedDetails &&
                    <Grid.Column width={16} >
                    <Link to={`/app/rewards/${this.props.match.params.category}/details/${this.props.match.params.rewardId}/redeemed`}>
                        
                        <Button className='buttonStyle' size="big">
                            View Redeemed Page
                        </Button>
                    </Link>
                    </Grid.Column>
                }
              </Segment>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        reward: state.appConfig.reward,
    }
}

export default connect(mapStateToProps, {
    getMHCRewardsDetail,
    redeemMHCRewards,
})(RewardsDetailsPage);
